import { allTrackers } from "app/services/track/track";

export const competitorsTracking = {
    onTableSort: (columnName: string, countryCodes: number[]): void => {
        allTrackers.dispatchTrackEvent("Sort", "click", `Competitors/${columnName}`, {
            country: countryCodes.join(", "),
        });
    },
    onGranularityChange: (granularity: string, countryCodes: number[]): void => {
        allTrackers.dispatchTrackEvent("Switch", "switch", `Graph Granularity Change/${granularity}`, {
            country: countryCodes.join(", "),
        });
    },
    onChartFilter: (track: { action: string; replacements?: Record<string, string> }): void => {
        allTrackers.dispatchTrackEvent(
            "Filter Chart",
            track.action,
            `Monitor & Protect/Competitors/Over Time chart`,
            track.replacements,
        );
    },
};
